import {
    //user
    SET_USER_DATA,
    
    //sellpoints
    ADD_SELLPOINT,
    ADD_SELLPOINT_SUCCESS,
    ALL_SELLPOINTS,
    ALL_SELLPOINTS_SUCCESS,
    USER_SELLPOINTS,
    USER_SELLPOINT,
    USER_SELLPOINT_APP_SUB_OFFERS,
    USER_SELLPOINT_SHIPPING,
    USER_SELLPOINT_DISCOUNTS,
    //
    SET_SELLPOINT_CATEGORIES,
    RESET_SELLPOINTS,

    //categories
    USER_SELLPOINT_CATEGORIES,
    USER_SELLPOINT_CATEGORY,

    //products
    USER_SELLPOINT_CATEGORY_PRODUCTS,
    USER_SELLPOINT_PRODUCTS,
    USER_SELLPOINT_PRODUCT,
    ADD_PRODUCT,
    ADD_PRODUCT_SUCCESS,
    ALL_PRODUCTS,
    ALL_PRODUCTS_SUCCESS,
    PRODUCT_BY_ID,
    PRODUCT_BY_ID_SUCCESS,

    //cart
    VIEW_CART,
    ADD_TO_CART,
    REMOVE_FROM_CART,

    //messages
    ERROR_MSG,

  } from './../../mutation-types'
  
  //user
  export const accountUserMutations = {

    [SET_USER_DATA] (state, payload) {
       state.store_user = payload;
    }, // -> commit('account/SET_USER_DATA')

    [ERROR_MSG] (state, payload) {}
    
  }

  //sellpoints
  export const accountSellpointMutations = {
    [USER_SELLPOINTS] (state,payload) {
      state.store_showLoader = false
      state.store_sellpoints = payload
    },

    [USER_SELLPOINT] (state,payload) {
      state.store_showLoader = false
      state.store_sellpoint.store_sellpointData = payload
    },

    [SET_SELLPOINT_CATEGORIES] (state,payload) {
        state.store_sellpoint.business_categories = payload
        state.store_sellpoint.store_sellpointData.business_categories = payload
    },

    [USER_SELLPOINT_APP_SUB_OFFERS] (state,payload) {
        state.store_sellpoint.store_sellpointAppSubscriptionOffers = payload
    },

    [USER_SELLPOINT_SHIPPING] (state,payload) {
        state.store_sellpoint.store_sellpointShipping = payload
    },

    [USER_SELLPOINT_DISCOUNTS] (state,payload) {
        state.store_sellpoint.store_sellpointDiscounts = payload
    },

    [RESET_SELLPOINTS] (state) {
        //state.store_sellpoints = {}
        state.store_sellpoint = {};
        // state.replaceState({
        //     store_sellpoints: {},
        // })
    },
  

    [ERROR_MSG] (state, payload) {},
    
    [ALL_SELLPOINTS] (state) {
        state.store_showLoader = true
        // this[]
    },

    [ALL_SELLPOINTS_SUCCESS] (state, payload) {
        state.store_showLoader = false
        state.store_sellpoints = payload
    },
      
  }

    //categories
    export const accountCategoryMutations = {
        [USER_SELLPOINT_CATEGORIES](state, payload) {
            state.store_sellpoint.store_categories = payload
        },

        [USER_SELLPOINT_CATEGORY](state, payload) {
            state.store_sellpoint.store_category = payload
        },

        [ERROR_MSG] (state, payload) {}
    }

    //products
    export const accountProductMutations = {
        [USER_SELLPOINT_PRODUCTS](state, payload) {
            state.store_sellpoint.store_products = payload
        },

        [USER_SELLPOINT_CATEGORY_PRODUCTS](state, payload) {
            state.store_sellpoint.store_category_products = payload
        },

        [USER_SELLPOINT_PRODUCT](state, payload) {
            state.store_sellpoint.store_product = payload
        },

        [ALL_PRODUCTS] (state) {
            state.store_showLoader = true
        // this[]
        },

        [ALL_PRODUCTS_SUCCESS] (state, payload) {
            state.store_showLoader = false
            state.store_sellpoint.store_products = payload
        },

        [PRODUCT_BY_ID] (state) {
            state.store_showLoader = true
        },
        
        [PRODUCT_BY_ID_SUCCESS] (state, payload) {
            state.store_showLoader = false
            state.store_sellpoint.store_product = payload
        },

        [ERROR_MSG] (state, payload) {}

    }
  
  


// WEBPACK FOOTER //
// ./src/store/modules/account/mutations.js